import { navigate } from '@reach/router';
import { projectUrls } from '../../projects/projectUrls';
import { NextStepAfterSavingDesign } from './DesignFormButtons';

export const navigateAfterSavingDesign = (
  projectId: number,
  designId: number,
  isDraft: boolean,
  nextStepAfterSave: NextStepAfterSavingDesign,
) => {
  if (isDraft) {
    return navigate(projectUrls.editDesign(projectId, designId));
  }

  return nextStepAfterSave === 'ConfigurePdf'
    ? navigate(projectUrls.dataForDesignDrawings(projectId, designId))
    : navigate(projectUrls.projectDetails(projectId));
};
